var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"topbar",class:_vm.scrollDirection === 'down' ? 'hide' : 'show'},[_c('div',{staticClass:"bg"}),_c('div',{staticClass:"wrapper"},[_c('div'),_c('div',[_c('Logo',{nativeOn:{"click":function($event){return _vm.scrollToTop.apply(null, arguments)}}})],1),_c('div',[_c('LocaleButton')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }